import React, { useEffect, useState } from 'react';
import { companyService } from '../../services/api';
import './Loader.css';

const Loader = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [branding, setBranding] = useState({
    name: 'Record & Stock Management System',
    logo: '/logo.png'
  });

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await companyService.getBranding();
        if (response.data) {
          setBranding({
            name: response.data.name || 'Record & Stock Management System',
            logo: response.data.logo || '/logo.png'
          });
        }
      } catch (err) {
        console.error('Failed to fetch branding:', err);
      }
    };
    fetchBranding();

    // Update percentage counter
    const interval = setInterval(() => {
      setPercentage((prev) => {
        if (prev >= 100) return 100;
        return prev + 2;
      });
    }, 100);

    // Trigger fade out before component unmounts (4.5 seconds to allow 0.5s fade out)
    const timer = setTimeout(() => {
      setFadeOut(true);
      clearInterval(interval);
    }, 4500);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={`loader-overlay ${fadeOut ? 'fade-out' : ''}`}>
      {/* Floating Icons Background */}
      <div className="loader-floating-icons">
        <div className="floating-icon icon-1">
          <i className="bi bi-file-earmark-text"></i>
        </div>
        <div className="floating-icon icon-2">
          <i className="bi bi-box-seam"></i>
        </div>
        <div className="floating-icon icon-3">
          <i className="bi bi-folder"></i>
        </div>
        <div className="floating-icon icon-4">
          <i className="bi bi-clipboard-data"></i>
        </div>
        <div className="floating-icon icon-5">
          <i className="bi bi-archive"></i>
        </div>
        <div className="floating-icon icon-6">
          <i className="bi bi-file-earmark-spreadsheet"></i>
        </div>
        <div className="floating-icon icon-7">
          <i className="bi bi-inbox"></i>
        </div>
        <div className="floating-icon icon-8">
          <i className="bi bi-building"></i>
        </div>
      </div>

      <div className="loader-container">
        <div className="loader-logo">
          <img
            src={branding.logo}
            alt="Company Logo"
            className="loader-logo-img"
          />
        </div>

        <div className="loader-system-name">
          <h2 className="loader-main-title">Record & Stock Management</h2>
          <p className="loader-system-subtitle">System</p>
        </div>

        <div className="loader-icons-row">
          <div className="loader-icon-item">
            <div className="loader-icon-wrapper">
              <i className="bi bi-file-earmark-text"></i>
            </div>
            <span>Records</span>
          </div>
          <div className="loader-icon-item">
            <div className="loader-icon-wrapper">
              <i className="bi bi-box-seam"></i>
            </div>
            <span>Stock</span>
          </div>
          <div className="loader-icon-item">
            <div className="loader-icon-wrapper">
              <i className="bi bi-graph-up"></i>
            </div>
            <span>Analytics</span>
          </div>
        </div>

        <div className="loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>

        <div className="loader-text">
          <h3 className="loader-title">
            <span className="loader-dots">
              <span>L</span>
              <span>o</span>
              <span>a</span>
              <span>d</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </span>
          </h3>
          <p className="loader-subtitle">Preparing your dashboard</p>
        </div>

        <div className="loader-progress-container">
          <div className="loader-progress">
            <div className="loader-progress-bar">
              <div className="loader-progress-shine"></div>
            </div>
          </div>
          <div className="loader-progress-text">
            <span className="loader-percentage">{percentage}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
